<template>
  <div
    :class="{ additionalFilterActions: additionalFilters.length && filterIsEnable }"
    :style="`width: 100%; ${
      additionalFilters.length && filterIsEnable
        ? enableIconCreate
          ? 'padding-right: 64px !important'
          : 'padding-right: 32px !important'
        : filterIsEnable
        ? 'padding-right: 40px !important'
        : 'padding-right: 20px !important'
    } ${noPadding ? 'padding-right: 0 !important' : ''}`"
  >
    <div style="position: relative">
      <button
        type="button"
        :style="`${
          filterIsEnable
            ? 'border-radius: 0'
            : 'border-radius:0 0.25rem 0.25rem 0'
        }`"
        :class="`iconSelectInfinit ${isDisabled && 'iconDisabledInfinit'}`"
        v-if="enableIconCreate"
        :disabled="isDisabled"
        :aria-label="`Criar ${label}`"
        :title="`Criar ${label}`"
        @click="createModal"
      >
        <b-icon-plus :scale="additionalFilters.length && filterIsEnable ? 1.2 : 2"></b-icon-plus>
      </button>

      <button
        type="button"
        :class="['iconFilterSelectInfinit', { iconDisabledInfinit: isDisabled, additionalFilterActive: Object.keys(appliedFilters).length > 0 }]"
        v-if="filterIsEnable"
        :disabled="isDisabled"
        :aria-expanded="filterIsOpen"
        aria-label="Filtrar opções"
        title="Filtrar opções"
        @click="toggleFilter"
        ref="boxClick"
      >
        <b-icon-filter :scale="additionalFilters.length ? 1.15 : 1.3"></b-icon-filter>
        <span v-if="additionalFilters.length && Object.keys(appliedFilters).length" class="additionalFilterDot" aria-hidden="true"></span>
      </button>

      <div
        class="boxFilter"
        :class="{ boxFilterWithExtras: additionalFilters.length > 0, boxFilterWithoutCreate: !enableIconCreate }"
        ref="box"
        :style="!filterIsOpen && 'display: none'"
      >
        <div class="containerRadio">
          <label>
            <input
              type="radio"
              :name="`radio-${this.typeFilter}`"
              v-model="filterType"
              value="includes"
            />
            <span style="border-radius: 5px 0 0 5px">Contém</span>
          </label>

          <label>
            <input
              type="radio"
              :name="`radio-${this.typeFilter}`"
              v-model="filterType"
              value="start"
            />
            <span style="border-radius: 0 5px 5px 0">Iniciar por</span>
          </label>
        </div>
        <button
          v-if="additionalFilters.length"
          type="button"
          class="openAdditionalFilters"
          @click="openAdditionalFilters"
        >
          Filtros adicionais
        </button>
      </div>

      <label v-if="showLabel && defaultLabel" class="floatLabel">
        {{ label }}
      </label>
      <label v-else-if="showLabel && !defaultLabel" class="defaultLabel">
        {{ label }}:
      </label>

      <v-select
        :value="selected"
        :label="text"
        :options="dataList"
        :filterable="false"
        :loading="loading ? true : false"
        :custom-filter="customFilter"
        :disabled="isDisabled"
        @input="setSelected"
        @open="onOpen"
        @close="onClose"
        @search="searchByWriting"
        @blur="clearInvalidInput"
      >
        <template #list-footer>
          <li v-show="hasNextPage" ref="load" class="loader">
            Carregando mais...
          </li>
        </template>

        <template #no-options>
          <div>Resultado não encontrado!</div>
        </template>

        <template #spinner="{ loading }">
          <div
            v-if="loading"
            style="border-left-color: rgba(88, 151, 251, 0.71)"
            class="vs__spinner"
          ></div>
        </template>
      </v-select>
    </div>
    <AdditionalFiltersModal
      v-if="additionalFilters.length"
      ref="additionalFiltersModal"
      :fields="additionalFilters"
      :appliedFilters="appliedFilters"
      @opening="$emit('openFilters')"
      @apply="applyAdditionalFilters"
    />
  </div>
</template>

<script>
import { debounce } from "../../../utils/debounce";
import AdditionalFiltersModal from "./AdditionalFiltersModal.vue";

export default {
  name: "InfiniteScroll",
  components: { AdditionalFiltersModal },
  props: {
    dataInput: {
      type: String,
      default: "",
    },
    isEdit: {
      type: String,
    },
    text: {
      type: String,
      default: "nome",
    },
    value: {
      type: String,
      default: "id",
    },
    onSearch: {
      type: Function,
    },
    label: {
      type: String,
      default: "label",
    },
    enableIconCreate: {
      type: Boolean,
      default: true,
    },
    openCreateModal: {
      type: Function,
    },
    isDisabled: {
      type: Boolean,
    },
    findAll: {
      type: Boolean,
      default: false,
    },
    defaultLabel: {
      type: Boolean,
      default: true,
    },
    clearSelected: {
      type: Boolean,
      default: false,
    },
    searchFields: {
      typeof: Array,
    },
    filterIsEnable: {
      type: Boolean,
      default: true,
    },
    typeFilter: {
      type: String,
      default: "default",
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    additionalFilters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      observer: null,
      dataList: [],
      selected: null,
      hasNextPage: false,
      debouncedChanged: debounce(this.search),
      loading: false,
      filterIsOpen: false,
      filterType: "includes",
      page: 1,
      pageSize: 20,
      searchQuery: "",
      debouncedSearch: null,
      scrollPosition: 0,
      appliedFilters: {},
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll);
    this.removeClearButtonTitle();

    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    this.observer.disconnect();
    if (
      this.debouncedSearch &&
      typeof this.debouncedSearch.cancel === "function"
    ) {
      this.debouncedSearch.cancel();
    }
    document.removeEventListener("click", this.handleClickOutside);
  },
  created() {
    this.debouncedSearch = debounce((search) => {
      if (this.loading) return;
      this.searchQuery = search;
      this.search(false);
    }, 350);
    this.findInitial();
  },
  methods: {
    async search(loadingMore = false) {
      if (this.loading && loadingMore) return;
      this.loading = true;

      if (!loadingMore) {
        this.page = 1;
        this.dataList = [];
        this.hasNextPage = false;
      }

      try {
        const pageToSend = this.page || 1;

        const newItems = await this.onSearch(
          this.isEdit && !this.selected ? this.dataInput : "",
          this.searchQuery,
          this.filterType,
          pageToSend,
          this.appliedFilters
        );

        if (newItems && Array.isArray(newItems)) {
          const itemsToProcess = loadingMore
            ? newItems
            : this.getUniqueItems(newItems);

          if (loadingMore) {
            const existingIds = new Set(this.dataList.map((p) => p.id));
            const uniqueNewItems = itemsToProcess.filter(
              (p) => !existingIds.has(p.id)
            );
            this.dataList.push(...uniqueNewItems);

            this.$nextTick(() => {
              const menu = this.$el.querySelector(".vs__dropdown-menu");
              if (menu) menu.scrollTop = this.scrollPosition;
            });
          } else {
            this.dataList = itemsToProcess;
          }

          this.hasNextPage = newItems.length === this.pageSize;
          this.page = pageToSend + 1;
        } else {
          if (loadingMore) this.hasNextPage = false;
        }

        this.observeLoader();
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        this.hasNextPage = false;
      } finally {
        this.loading = false;
      }
    },
    async findInitial() {
      this.loading = true;

      if (this.dataInput) {
        const result = await this.onSearch(
          this.dataInput,
          "",
          this.filterType,
          1,
          this.appliedFilters
        );

        this.selected = result.find(
          (item) => item[this.value] === this.dataInput
        );

        this.$emit("selectItem", this.selected);

        this.dataList = result;
      } else {
        this.dataList = await this.onSearch(
          "",
          "",
          this.filterType,
          1,
          this.appliedFilters
        );
      }

      this.loading = false;
    },
    async findToEdit() {
      this.loading = true;

      const result = await this.onSearch(
        this.dataInput,
        "",
        this.filterType,
        1,
        this.appliedFilters
      );
      this.selected = result.find(
        (item) => item[this.value] === this.dataInput
      );

      this.$emit("selectItem", this.selected);
      this.dataList = result;

      this.loading = false;
    },
    async infiniteScroll(entries) {
      const loaderEntry = entries[0];
      if (loaderEntry.isIntersecting && this.hasNextPage) {
        this.observer.unobserve(loaderEntry.target);
        const menu = this.$el.querySelector(".vs__dropdown-menu");
        if (menu) this.scrollPosition = menu.scrollTop;
        await this.search(true);
      }
    },
    onOpen() {
      this.observeLoader();
    },
    searchByWriting(search) {
      this.debouncedSearch(search);
    },
    setSelected(itemSelect) {
      this.selected = itemSelect;

      if (itemSelect) {
        this.$emit("update:dataInput", itemSelect[this.value]);
        this.$emit("selectItem", itemSelect);
      } else {
        this.$emit("update:dataInput", "");
        this.$emit("selectItem", "");
      }
    },

    onClose() {
      this.observer.disconnect();
    },

    removeClearButtonTitle() {
      this.$nextTick(() => {
        const clearButton = document.querySelector(".vs__clear");
        if (clearButton) {
          clearButton.title = "Remover seleção";
        }
      });
    },

    createModal() {
      if (this.openCreateModal) return this.openCreateModal();

      return;
    },
    customFilter(option, label, search) {
      const searchLower = search.toLowerCase();

      if (this.searchFields && this.searchFields.length) {
        return this.searchFields.some((field) =>
          String(option[field]).toLowerCase().includes(searchLower)
        );
      }

      return option[this.text].toLowerCase().includes(searchLower);
    },

    toggleFilter() {
      this.filterIsOpen = !this.filterIsOpen;
    },
    openAdditionalFilters() {
      this.filterIsOpen = false;
      this.$refs.additionalFiltersModal.open();
    },
    applyAdditionalFilters(filters) {
      this.appliedFilters = filters;
      this.search();
    },
    handleClickOutside(event) {
      const box = this.$refs.box;
      const boxClick = this.$refs.boxClick;

      if (
        box &&
        !box.contains(event.target) &&
        boxClick &&
        !boxClick.contains(event.target)
      ) {
        this.filterIsOpen = false;
      }
    },

    clearInvalidInput() {
      this.$emit("clearInvalidInput");
    },
    observeLoader() {
      if (this.hasNextPage) {
        this.$nextTick(() => {
          const loader = this.$refs.load;
          if (loader) this.observer.observe(loader);
        });
      }
    },
    getUniqueItems(items) {
      const uniqueIds = new Set();
      return items.filter((item) => {
        if (uniqueIds.has(item.id)) return false;
        uniqueIds.add(item.id);
        return true;
      });
    },
  },
  watch: {
    clearSelected() {
      this.selected = "";
    },
    isEdit() {
      this.findToEdit();
    },
    findAll() {
      this.findInitial();
    },
  },
};
</script>

<style>
.loader {
  text-align: center;
  color: #bbbbbb;
  height: 30px !important;
  padding-top: 5px;
}

.boxFilter {
  display: flex;
  height: 30px;
  justify-content: space-between;
  background-color: white;
  position: absolute;
  top: 33px;
  right: -40px;
  z-index: 500;
  border-radius: 5px;
  box-shadow: 0 0 3px 0 #0000006b;
}

.boxFilterWithExtras {
  flex-direction: column;
  height: auto;
  padding: 4px;
}

.openAdditionalFilters {
  padding: 5px 8px;
  border: 0;
  border-radius: 4px;
  background: #006256;
  color: white;
  font-size: 11px;
  cursor: pointer;
}

.boxFilter::before {
  content: "";
  position: absolute;
  top: -8px;
  right: 3px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid white;
  z-index: -99999;
}

.vs__dropdown-toggle {
  height: 30px;
}

.vs__search {
  font-size: 12px !important;
  color: #495057 !important;
}

.vs__dropdown-option {
  white-space: normal !important;
  font-size: 11px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.vs__dropdown-menu {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  font-size: 12px;
}

.vs__selected {
  font-size: 12px !important;
}

.vs__dropdown-toggle {
  width: 100%;
  white-space: normal !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  padding: 0 0 4px;
}

.vs1__listbox {
  width: 100%;
  white-space: normal !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.vs__dropdown-option--highlight {
  white-space: normal !important;
  word-break: break-all !important;
}

.vs__dropdown-menu {
  padding: 0 0 5px 0 !important;
  text-overflow: ellipsis !important;
}

.vs__dropdown-menu {
  padding: 0 0 5px 0 !important;
}

.floatLabel {
  position: absolute;
  left: 3px;
  font-size: 8.5px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  top: -9px;
  left: 7px;
  pointer-events: none;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  height: 12px;
  background-color: #ffff;
  padding: 0 0.2em;
  z-index: 999;
}

.defaultLabel {
  position: absolute;
  margin-bottom: 0px;
  font-size: 11px;
  bottom: 30px;
  left: 0px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: transparent;
  font-weight: 600;
  z-index: 1000;
}

.iconSelectInfinit {
  position: absolute;
  right: -18px !important;
  top: 0 !important;
  z-index: 10;
  background-color: #006256;
  color: whitesmoke;
  height: 100%;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 0;
  padding: 0;
  border-radius: 0 0.25rem 0.25rem 0;
}

.iconDisabledInfinit {
  pointer-events: none !important;
}

.iconFilterSelectInfinit {
  position: absolute;
  right: -38px !important;
  top: 0 !important;
  z-index: 10;
  background-color: #006256;
  color: whitesmoke;
  height: 100%;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 0;
  border-radius: 0 0.25rem 0.25rem 0;
  border-left: solid 1px rgba(129, 129, 129, 0.26);
}

.additionalFilterActions .iconSelectInfinit,
.additionalFilterActions .iconFilterSelectInfinit {
  width: 28px;
  height: 30px;
  top: 0 !important;
  border: 0;
  border-radius: 4px !important;
  padding: 0;
  box-sizing: border-box;
}

.additionalFilterActions .iconSelectInfinit {
  right: -30px !important;
}

.additionalFilterActions .iconFilterSelectInfinit {
  right: -62px !important;
}

.additionalFilterActions .iconFilterSelectInfinit:first-child {
  right: -30px !important;
}

.additionalFilterActions .boxFilter {
  right: -62px;
}

.additionalFilterActions .boxFilterWithoutCreate {
  right: -30px;
}

.additionalFilterDot {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffc857;
  box-shadow: 0 0 0 1px #006256;
}

.additionalFilterActions .iconSelectInfinit:focus-visible,
.additionalFilterActions .iconFilterSelectInfinit:focus-visible {
  outline: 2px solid #006256;
  outline-offset: 2px;
}

.iconFilterSelectInfinit:hover {
  background: #006256;
}

.iconDisabledInfinit {
  pointer-events: none !important;
}

.containerRadio {
  display: flex;
}

.containerRadio label {
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0;
}

.containerRadio label input {
  position: absolute;
  left: -9999px;
}

.iconSelectInfinit:hover {
  background: #006256;
}

.containerRadio label input:checked + span {
  background-color: #f3f2f2;
  color: rgb(0, 0, 0);
}

.containerRadio label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #006256;
}

.containerRadio label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 2px;
  transition: 0.25s ease;
  font-size: 11px;
}

.containerRadio label span:hover {
  background-color: #e6e6e6;
}

.containerRadio label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  margin-right: 0.375em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.1em #006256;
}

@media (max-width: 768px) {
  .floatLabel {
    position: absolute;
    left: 3px;
    font-size: 11px;
    font-family: Poppins-Regular, sans-serif !important;
    font-weight: 600;
    top: -10px;
    left: 7px;
    pointer-events: none;
    white-space: nowrap !important;
    text-overflow: ellipsis;
    color: #666360;
    height: 12px;
    background-color: #ffff;
    padding: 0 0.2em;
    z-index: 999;
  }
}
</style>
